import { useEffect, useRef } from 'react';
import { GridPageLayout as GridPageLayoutFrame, type GridPageLayoutProps } from './GridPageLayout';

/**
 * The public Grid page layout.
 */
export function GridPageLayout(props: GridPageLayoutProps) {
  const layoutRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const closeMenuOnOutsidePointer = (event: PointerEvent) => {
      const layout = layoutRef.current;
      const target = event.target;
      if (!layout || !(target instanceof Node)) return;

      const openTrigger = layout.querySelector<HTMLButtonElement>('button[aria-haspopup="menu"][aria-expanded="true"]');
      if (!openTrigger) return;
      // Menus render via a portal into document.body, so they're never inside
      // `layout`'s own DOM subtree — search the whole document for them.
      const openMenus = Array.from(document.querySelectorAll<HTMLElement>('[role="menu"]'));
      if (openTrigger.contains(target) || openMenus.some((menu) => menu.contains(target))) return;

      openTrigger.click();
    };

    document.addEventListener('pointerdown', closeMenuOnOutsidePointer);
    return () => document.removeEventListener('pointerdown', closeMenuOnOutsidePointer);
  }, []);

  return <div ref={layoutRef} className="min-h-0 min-w-0 w-full"><GridPageLayoutFrame {...props} /></div>;
}
